<div class="fullscreen-overlay">
  <div class="content content-lg">
    @if (isSubCardUpgrade()) {
      <img
        src="./assets/upgrade/upgrade-sub.svg"
        height="141"
        width="164"
        alt="Upgrade to Premium" />
      <h4 class="text-white">Take control of your subscriptions</h4>
      <p class="lead">
        Keep your SaaS subscriptions separate from day-to-day employee spending.<br />
        Create dedicated cards for recurring payments for better cost control.
      </p>
      <div class="card bg-white bg-opacity-25 border-0 mb-3">
        <div class="card-body p-3 text-white">
          <div class="row align-items-center justify-content-center row-cols-1 row-cols-md-auto gy-3 flex-xl-nowrap">
            <div class="col text-nowrap">
              <i class="iconoir-check-circle"></i>
              Track SaaS spend in one place
            </div>
            <div class="col text-nowrap">
              <i class="iconoir-check-circle"></i>
              Stop surprise renewals
            </div>
            <div class="col text-nowrap">
              <i class="iconoir-check-circle"></i>
              Cancel subscriptions any time
            </div>
          </div>
        </div>
      </div>
    } @else if (isIntegrationUpgrade()) {
      <img
        src="./assets/upgrade/upgrade-integration.svg"
        height="165"
        width="214"
        alt="Upgrade to Premium" />
      <h4 class="text-white">Seamless accounting integration</h4>
      <p>
        Connect Paystashio directly to your accounting software and eliminate manual reconciliations. <br />
        Save hours each month and keep your books accurate and up to date.
      </p>

      <div class="card bg-white bg-opacity-25 border-0 mb-3">
        <div class="card-body p-3 text-white">
          <div class="row align-items-center justify-content-center row-cols-1 row-cols-md-auto gy-3 flex-xl-nowrap">
            <div class="col text-nowrap">
              <i class="iconoir-check-circle"></i>
              Automatic transaction syncing
            </div>
            <div class="col text-nowrap">
              <i class="iconoir-check-circle"></i>
              Faster, cleaner month-end close
            </div>
            <div class="col text-nowrap">
              <i class="iconoir-check-circle"></i>
              Fewer errors and no manual uploads
            </div>
          </div>
        </div>
      </div>
    }
    <a
      routerLink="/your-plan/upgrade-plan"
      class="btn btn-primary">
      Upgrade your plan
    </a>
  </div>
</div>
